import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/MenuItinerary.sass';

const MenuItineraryBogota = () => (
  <div className="row MenuItinerary --bogota">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuItinerary__list">
            <li className="MenuItinerary__list--item">
            <NavLink to="/volcano-mtb/itinerary/start">
                INICIO
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/day-1">
                DÍA 1
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/day-2">
                DÍA 2
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/day-3">
                DÍA 3
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/day-4">
                DÍA 4
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/day-5">
                DÍA 5
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/day-6">
                DÍA 6
              </NavLink>
            </li>
            <li className="MenuItinerary__list--item">
              <NavLink to="/volcano-mtb/itinerary/finish">
                FINAL
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default MenuItineraryBogota;